import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Colorlogo } from "../../controller/Images";
import { navItems } from "../../controller/Navdata";
import Styles from "../header/HeaderNavbar.module.css";

function MobileHeader() {
  const [isOpen, setIsOpen] = useState(false);
  const [openSubmenuId, setOpenSubmenuId] = useState(null);

  const toggleSubmenu = (id) => {
    setOpenSubmenuId((prev) => (prev === id ? null : id));
  };

  return (
    <nav className="navbar navbar-expand-lg bg-light d-lg-none">
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          <img src={Colorlogo} alt="Company Logo" height="50" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`collapse navbar-collapse ${isOpen ? "show" : ""} ${
            Styles.toggle_view
          }`}
        >
          <ul className="navbar-nav ms-auto">
            {navItems
              .filter((link) => link.id !== "logo")
              .map((link, index) => {
                const hasChildren = link.children && link.children.length > 0;
                const isSubOpen = openSubmenuId === link.id;

                return (
                  <li className="nav-item" key={index}>
                    {hasChildren ? (
                      <>
                        <div
                          className="nav-link d-flex justify-content-between align-items-center"
                          onClick={() => toggleSubmenu(link.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <span>{link.name}</span>

                          <span
                            style={{
                              transform: isSubOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.2s ease",
                              display: "inline-block",
                            }}
                          >
                            ▾
                          </span>
                        </div>

                        {isSubOpen && (
                          <ul
                            className="list-unstyled"
                            style={{
                              paddingLeft: "20px",
                              marginTop: "-5px",
                            }}
                          >
                            {link.children.map((child) => (
                              <li key={child.path}>
                                <a className="nav-link py-1" href={child.path}>
                                  {child.name}
                                </a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </>
                    ) : (
                      <a className="nav-link" href={link.path}>
                        {link.name}
                      </a>
                    )}
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default MobileHeader;
